module.exports = __webpack_public_path__ + "static/img/Jack_Billings_mobile.ebfb6e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack_Billings_mobile.jpg
// module id = CFki
// module chunks = 0